import React from "react";
import PropTypes from 'prop-types';

const Cardview = ({ data, detalle,  frmData, setFrmData }) => 
  {
    const handleSelecciona = (event, MenuId,ItemId) =>
      {
        const Estado = event.target.checked ? 'SI' : 'NO';
        setFrmData(prev =>
             prev.map(e =>
                e.MenuId === MenuId && e.ItemId === ItemId ? { ...e, Estado } : e
               )
        ); 
      }      
 return (
  <>
    <div className="flex flex-col w-full h-full p-6 space-x-4" id={`card${data.MenuId}`}>
      <div className="text-gray-700 font-semibold border-b border-gray-700 mb-2">
        {data.NombreMenu}
      </div>     
      <div className=" whitespace-nowrap text-gray-700 mt-2">
        {detalle.map((item) => 
         {
           return (
              <div className="flex flex-row space-x-2"  key={`${item.MenuId}${item.ItemId}`}>
                <div> 
                  <input
                    type="checkbox"
                    id={`${item.MenuId}${item.ItemId}`}
                    name={`${item.MenuId}${item.ItemId}`}
                    className="checkbox"
                    checked={
                      frmData.some(
                        f =>
                        f.MenuId === Number(item.MenuId) &&
                        f.ItemId === Number(item.ItemId) &&
                        f.Estado === 'SI'
                      )
                    }
                    onChange={(e) => handleSelecciona(e, item.MenuId, item.ItemId)}
                   />
                  </div>
                  <div className="">{item.NombreItem}</div>
               </div>
            );
          })}
      </div>
    </div>
 </>
  );
}

Cardview.propTypes = {
  data: PropTypes.object.isRequired,
  detalle: PropTypes.array.isRequired, 
  permiso: PropTypes.array.isRequired,
  frmData: PropTypes.object.isRequired,
  setFrmData:PropTypes.func.isRequired
};

export default Cardview;
